module.exports = __webpack_public_path__ + "assets/img/vpp_lv.52670543.jpg";